import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=6c5bfa76&scoped=true"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoriesMenu.vue?vue&type=style&index=0&id=6c5bfa76&prod&lang=css"
import style1 from "./CategoriesMenu.vue?vue&type=style&index=1&id=6c5bfa76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bfa76",
  null
  
)

export default component.exports